import { Card, Chip, Grid, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { BILightYellow } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_ACTIONS } from "../../constant/Apipath";
import {
  BIGreen,
  BIGrey,
  BILightGreen,
  BILightGrey,
  BILightRed,
  BIRed
} from "../../assets/helpers";
import TabsComponent from "../component/TabsComponent";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientActions() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [currentTab, setCurrentTab] = useState("1");
  const [actionsList, setActionsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNO] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigation = useNavigate();

  const {
    TEXT_DUE,
    TEXT_NO_RECEIVED_ACTIONS,
    TEXT_NO_SUBMITTED_ACTIONS,
    TEXT_RECEIVED,
    TEXT_SUBMITTED
  } = ClientEnglishFallback?.Actions(multiLanguageData?.Actions || {});

  useEffect(() => {
    getActionsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]);

  const getActionsList = async () => {
    try {
      setIsLoading(true);
      const obj = {
        PageNr: pageNo,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "dueDate",
            Direction: "Desc"
          }
        ],
        SearchList: [
          currentTab === "1"
            ? { EmployeeId: selectedClientData?.ClientEmployeeId }
            : { UserId: loginData?.userInformation?.UserId, clientId: selectedClientData?.ClientId }
        ]
      };
      const actionsRes = await Postrequestcall(FETCH_CLIENT_ACTIONS, obj, loginData?.accessToken);
      if (actionsRes?.status === 200) {
        if (actionsRes?.data?.data?.length > 0) {
          setHasMore(true);
          setPageNO((prev) => prev + 1);
          setActionsList([...actionsList, ...actionsRes?.data?.data]);
        } else {
          setHasMore(false);
        }

        setIsLoading(false);
      }
    } catch (err) {
      console.log("getActionsList-> Error When Getting Client Actions: ", err);
      setIsLoading(false);
    }
  };

  const handleChange = (newValue) => {
    if (currentTab === newValue) {
      return;
    }
    setCurrentTab(newValue);
    setPageNO(1);
    setActionsList([]);
  };

  const handelNavigateToDetails = (item) => {
    let tab = "";
    if (currentTab == 1) {
      tab = "Received";
    } else {
      tab = "Submitted";
    }
    navigation(`${item?.id}`, {
      state: { currentTab: tab }
    });
  };

  const tabs = [
    {
      label: TEXT_RECEIVED,
      value: "1",
      translateLabel: TEXT_RECEIVED
    },
    {
      label: TEXT_SUBMITTED,
      value: "2",
      translateLabel: TEXT_SUBMITTED
    }
  ];
  return (
    <Stack style={{ gap: 8 }}>
      <TabsComponent tabs={tabs} setTabsValue={handleChange} tabValue={currentTab} />
      {isLoading && actionsList?.length === 0 ? (
        <Loader fullScreen />
      ) : (
        <div
          style={{
            maxHeight: "85vh",
            overflow: "auto",
            scrollbarWidth: "none"
          }}
          id="action_div">
          <InfiniteScroll
            scrollableTarget={"action_div"}
            dataLength={actionsList?.length}
            next={getActionsList}
            hasMore={hasMore}
            loader={<Loader />}>
            {actionsList?.length > 0 && (
              <>
                {actionsList?.map((item, index) => {
                  return (
                    <Card
                      key={index}
                      onClick={() => handelNavigateToDetails(item)}
                      style={{
                        borderRadius: 10,
                        marginBottom: 10,
                        padding: "10px 15px",
                        boxShadow: "none",
                        cursor: "pointer"
                      }}>
                      <Stack width={"100%"}>
                        <Grid direction={"column"} mb={1} container size={12}>
                          <Grid size={"grow"}>
                            <Stack justifyContent={"space-between"} flexDirection="row">
                              {currentTab === "2" && (
                                <Stack gap={1} alignItems={"center"} flexDirection="row">
                                  <PersonIcon
                                    style={{
                                      color: selectedClientData?.AccentColor
                                    }}
                                  />
                                  <Typography fontSize={16} variant="subtitle2">
                                    {item?.employeeName}
                                  </Typography>
                                </Stack>
                              )}
                              <Typography
                                gutterBottom
                                style={{
                                  color: BIGrey
                                }}>
                                {TEXT_DUE} {dayjs(item?.dueDate).format("MMMM DD, YYYY")}{" "}
                              </Typography>
                            </Stack>
                          </Grid>
                          <Grid size={12}>
                            <Typography
                              gutterBottom
                              sx={{
                                wordBreak: "break-all",
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1
                              }}>
                              {item?.title}
                            </Typography>
                          </Grid>
                          <Grid size={12}>
                            <Typography
                              gutterBottom
                              sx={{
                                wordBreak: "break-all",
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1,
                                color: BIGrey
                              }}>
                              {item?.description}
                            </Typography>
                          </Grid>
                          <Grid size={12}>
                            <Chip
                              label={item?.status}
                              style={
                                item?.status === "In Progress"
                                  ? {
                                      backgroundColor: BILightYellow,
                                      color: "brown"
                                    }
                                  : item?.status === "Overdue"
                                    ? {
                                        backgroundColor: BILightRed,
                                        color: BIRed
                                      }
                                    : item?.status === "Not Started"
                                      ? {
                                          backgroundColor: BILightGrey
                                        }
                                      : item?.status === "On Hold"
                                        ? {
                                            backgroundColor: "pink",
                                            color: "brown"
                                          }
                                        : {
                                            backgroundColor: BILightGreen,
                                            color: BIGreen
                                          }
                              }
                              sx={{
                                borderRadius: "15px"
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Stack>
                    </Card>
                  );
                })}
              </>
            )}
            {actionsList?.length === 0 && (
              <>
                <div
                  style={{
                    textAlign: "center",
                    alignContent: "center",
                    height: "83vh"
                  }}>
                  <Typography
                    sx={{
                      color: "grey",
                      fontWeight: "bold"
                    }}>
                    {currentTab === "1" ? TEXT_NO_RECEIVED_ACTIONS : TEXT_NO_SUBMITTED_ACTIONS}
                  </Typography>
                </div>
              </>
            )}
          </InfiniteScroll>
        </div>
      )}
    </Stack>
  );
}
